var _path, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNaira(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0486 11.3682H9.18082L4.95154 4.97754V11.3682H3.08372V2.04239H4.95154L9.18082 8.44636V2.04239H11.0486V11.3682Z",
    fill: "#00E194"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.828979,
    y: 4.50439,
    width: 12.0074,
    height: 1.33416,
    fill: "#00E194"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.828979,
    y: 7.17236,
    width: 12.0074,
    height: 1.33416,
    fill: "#00E194"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNaira);
export default __webpack_public_path__ + "static/media/naira.fff306683b5d728b012ce3032c21e4ad.svg";
export { ForwardRef as ReactComponent };